import { FormattedMessage } from "react-intl";

export const businessTypes = [
  {
    value: "FT",
    label: "RECRUITER.REGISTER.INPUT.SELECT.BUSSINESS.TYPE.BUILDING",
  },
  {
    value: "PT",
    label: "RECRUITER.REGISTER.INPUT.SELECT.BUSSINESS.TYPE.UNIVERSITY",
  },
  {
    value: "WKD",
    label: "RECRUITER.REGISTER.INPUT.SELECT.BUSSINESS.TYPE.IN_HOUSE_PROVIDERS",
  },
  {
    value: "OD",
    label: "RECRUITER.REGISTER.INPUT.SELECT.BUSSINESS.TYPE.MUNICIPALITIES",
  },
  {
    value: "ODM",
    label: "RECRUITER.REGISTER.INPUT.SELECT.BUSSINESS.TYPE.HOSPITALS",
  },
  {
    value: "ODAI",
    label: "RECRUITER.REGISTER.INPUT.SELECT.BUSSINESS.TYPE.AIRPORTS",
  },
  {
    value: "ODAR",
    label: "RECRUITER.REGISTER.INPUT.SELECT.BUSSINESS.TYPE.ARENAS",
  },
  {
    value: "ODR",
    label: "RECRUITER.REGISTER.INPUT.SELECT.BUSSINESS.TYPE.RESIDENTIAL",
  },
];

export const CandidateSortType = [
  {
    value: "newest",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.SORT.TYPE.NEWEST"
        defaultMessage="Apply date (newest)"
      />
    ),
  },
  {
    value: "oldest",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.SORT.TYPE.OLDEST"
        defaultMessage="Apply date (oldest)"
      />
    ),
  },
  {
    value: "a-z",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.SORT.TYPE.AZ"
        defaultMessage="Alphabetical (A-Z)"
      />
    ),
  },
  {
    value: "z-a",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.SORT.TYPE.ZA"
        defaultMessage="Alphabetical (Z-A)"
      />
    ),
  },
];
export const TabData = [
  {
    tabname: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.ACTIVE"
        defaultMessage="active"
      />
    ),
    value: "active",
  },
  {
    tabname: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.SHORTLIST"
        defaultMessage="shortlist"
      />
    ),
    value: "shortlist",
  },
  {
    tabname: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.AWAITINGREVIEW"
        defaultMessage="awaiting-reviews"
      />
    ),
    value: "awaiting-reviews",
  },
  {
    tabname: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.REVIEWED"
        defaultMessage="reviewed"
      />
    ),
    value: "reviewed",
  },
  {
    tabname: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.CONTACTING"
        defaultMessage="contacting"
      />
    ),
    value: "contacting",
  },
  {
    tabname: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.REJECTED"
        defaultMessage="rejected"
      />
    ),
    value: "rejected",
  },
  {
    tabname: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.HIRED"
        defaultMessage="hired"
      />
    ),
    value: "hired",
  },
  {
    tabname: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.WITHDRAWN"
        defaultMessage="withdrawn"
      />
    ),
    value: "withdrawn",
  },
];
export const MainWorkOrderStatus = [
  {
    value: "publish",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.PUBLISH"
        defaultMessage="Publish"
      />
    ),
  },
  {
    value: "draft",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.ASSIGNED.DRAFT"
        defaultMessage="Draft"
      />
    ),
  },
];

export const WorkOrderStatus = [
  {
    value: "scheduled",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.SCHEDULED"
        defaultMessage="Scheduled"
      />
    ),
    type: "workorder",
  },
    {
    value: "accepted",
    label: (
      <FormattedMessage
        id="RECRUITER.CONTRACT.WORKORDER.FILTER.TYPE.ACCEPTED"
        defaultMessage="Contract Accepted"
      />
    ),
    type: "contract",
  },
  {
    value: "rejected",
    label: (
      <FormattedMessage
        id="RECRUITER.CONTRACT.WORKORDER.FILTER.TYPE.REJECTED"
        defaultMessage="Contract Declined"
      />
    ),
    type: "contract",
  },
  {
    value: "in progress",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.INPROGRESS"
        defaultMessage="In Progress"
      />
    ),
    type: "workorder",
  },
  {
    value: "completed",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.COMPLETED"
        defaultMessage="Completed"
      />
    ),
    type: "workorder",
  },
];
export const ApprovalStatus = [
  {
    value: "pending",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.PENDING"
        defaultMessage="Pending"
      />
    ),
    type: "approval",
  },
  {
    value: "completed",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.APPROVED"
        defaultMessage="Approved"
      />
    ),
    type: "approval",
  },
  {
    value: "rejected",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.REJECTED"
        defaultMessage="Rejected"
      />
    ),
    type: "approval",
  },
];
export const PaymentStatus = [
  // { value: "pending", label: "Payment Pending", type: "payment" },
  { value: "completed", label: "Payment Completed", type: "payment" },
];
export const TaskStatus = [
  { value: "completed", label: "Completed" },
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
];

export const intentType = [
  {
    value: "Hiring",
    label: (
      <FormattedMessage
        id="RECRUITER.REGISTER.INPUT.CHOOSE.INTENT.TYPE.HIRING"
        defaultMessage="Hiring"
      />
    ),
  },
  {
    value: "Bidding",
    label: (
      <FormattedMessage
        id="RECRUITER.REGISTER.INPUT.CHOOSE.INTENT.TYPE.BIDDING"
        defaultMessage="Bidding"
      />
    ),
  },
  {
    value: "Subcontract",
    label: (
      <FormattedMessage
        id="RECRUITER.REGISTER.INPUT.CHOOSE.INTENT.TYPE.SUBCONTRACT"
        defaultMessage="Subcontract"
      />
    ),
  },
  {
    value: "work orders",
    label: (
      <FormattedMessage
        id="RECRUITER.REGISTER.INPUT.CHOOSE.INTENT.TYPE.SCHEDULING"
        defaultMessage="Scheduling"
      />
    ),
  },
];
export const province = [
  {
    label: "Alabama",
    value: "AL",
  },
  {
    label: "Alaska",
    value: "AK",
  },
  {
    label: "Arizona",
    value: "AZ",
  },
  {
    label: "Arkansas",
    value: "AR",
  },
  {
    label: "California",
    value: "CA",
  },
  {
    label: "Colorado",
    value: "CO",
  },
  {
    label: "Connecticut",
    value: "CT",
  },
  {
    label: "Delaware",
    value: "DE",
  },
  {
    label: "District Of Columbia",
    value: "DC",
  },
  {
    label: "Florida",
    value: "FL",
  },
  {
    label: "Georgia",
    value: "GA",
  },
  {
    label: "Hawaii",
    value: "HI",
  },
  {
    label: "Idaho",
    value: "ID",
  },
  {
    label: "Illinois",
    value: "IL",
  },
  {
    label: "Indiana",
    value: "IN",
  },
  {
    label: "Iowa",
    value: "IA",
  },
  {
    label: "Kansas",
    value: "KS",
  },
  {
    label: "Kentucky",
    value: "KY",
  },
  {
    label: "Louisiana",
    value: "LA",
  },
  {
    label: "Maine",
    value: "ME",
  },
  {
    label: "Maryland",
    value: "MD",
  },
  {
    label: "Massachusetts",
    value: "MA",
  },
  {
    label: "Michigan",
    value: "MI",
  },
  {
    label: "Minnesota",
    value: "MN",
  },
  {
    label: "Mississippi",
    value: "MS",
  },
  {
    label: "Missouri",
    value: "MO",
  },
  {
    label: "Montana",
    value: "MT",
  },
  {
    label: "Nebraska",
    value: "NE",
  },
  {
    label: "Nevada",
    value: "NV",
  },
  {
    label: "New Hampshire",
    value: "NH",
  },
  {
    label: "New Jersey",
    value: "NJ",
  },
  {
    label: "New Mexico",
    value: "NM",
  },
  {
    label: "New York",
    value: "NY",
  },
  {
    label: "North Carolina",
    value: "NC",
  },
  {
    label: "North Dakota",
    value: "ND",
  },
  {
    label: "Ohio",
    value: "OH",
  },
  {
    label: "Oklahoma",
    value: "OK",
  },
  {
    label: "Oregon",
    value: "OR",
  },
  {
    label: "Pennsylvania",
    value: "PA",
  },
  {
    label: "Rhode Island",
    value: "RI",
  },
  {
    label: "South Carolina",
    value: "SC",
  },
  {
    label: "South Dakota",
    value: "SD",
  },
  {
    label: "Tennessee",
    value: "TN",
  },
  {
    label: "Texas",
    value: "TX",
  },
  {
    label: "Utah",
    value: "UT",
  },
  {
    label: "Vermont",
    value: "VT",
  },
  {
    label: "Virginia",
    value: "VA",
  },
  {
    label: "Washington",
    value: "WA",
  },
  {
    label: "West Virginia",
    value: "WV",
  },
  {
    label: "Wisconsin",
    value: "WI",
  },
  {
    label: "Wyoming",
    value: "WY",
  },
];
export const payTypes = [
  {
    value: "perhour",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.RATE.PERHOUR",
  },
  {
    value: "perday",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.RATE.PERDAY",
  },
  {
    value: "perweek",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.RATE.PERWEEK",
  },
  {
    value: "permonth",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.RATE.PERMONTH",
  },
  {
    value: "peryear",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.RATE.PERYEAR",
  },
  {
    value: "perjob",
    label: "RECRUITER.POSTJOB.ADDPAYBENIFIT.INPUT.RATE.PERJOB",
  },
];

export const customerType = [
  {
    value: "Apartment building",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.APARTMENT.BUILDING"
        defaultMessage="Apartment building"
      />
    ),
  },
  {
    value: "Bank",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.BANK"
        defaultMessage="Bank"
      />
    ),
  },
  {
    value: "Church",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.CHURCH"
        defaultMessage="Church"
      />
    ),
  },
  {
    value: "Condo building",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.CONDO.BUILDING"
        defaultMessage="Condo building"
      />
    ),
  },
  {
    value: "Construction",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.CONSTRUCTION"
        defaultMessage="Construction"
      />
    ),
  },
  {
    value: "Franchise businesses",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.FRANCHISE.BUSINESSES"
        defaultMessage="Franchise businesses"
      />
    ),
  },
  {
    value: "Government building",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.GOVERNMENT.BUILDING"
        defaultMessage="Government building"
      />
    ),
  },
  {
    value: "Hospital",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.HOSPITAL"
        defaultMessage="Hospital"
      />
    ),
  },
  {
    value: "Hotel",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.HOTEL"
        defaultMessage="Hotel"
      />
    ),
  },
  {
    value: "Industrial building",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.INDUSTRIAL.BUILDING"
        defaultMessage="Industrial building"
      />
    ),
  },
  {
    value: "Medical facility",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.MEDICAL.FACILITY"
        defaultMessage="Medical facility"
      />
    ),
  },
  {
    value: "Museum",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.MUSEUM"
        defaultMessage="Museum"
      />
    ),
  },
  {
    value: "Office",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.OFFICE"
        defaultMessage="Office"
      />
    ),
  },
  {
    value: "Restaurant",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.RESTAURANT"
        defaultMessage="Restaurant"
      />
    ),
  },
  {
    value: "Retail store",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.RETAIL.STORE"
        defaultMessage="Retail store"
      />
    ),
  },
  {
    value: "School",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.SCHOOL"
        defaultMessage="School"
      />
    ),
  },
  {
    value: "Senior center",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.SENIOR.CENTER"
        defaultMessage="Senior center"
      />
    ),
  },
  {
    value: "Warehouse",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.WAREHOUSE"
        defaultMessage="Warehouse"
      />
    ),
  },
  {
    value: "Airbnb or vacation rental",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.AIRBNB.VACATION.RENTAL"
        defaultMessage="Airbnb or vacation rental"
      />
    ),
  },
  {
    value: "Apartment or condo",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.APARTMENT.OR.CONDO"
        defaultMessage="Apartment or condo"
      />
    ),
  },
  {
    value: "Home",
    label: (
      <FormattedMessage
        id="RECRUITER.CUSTOMER.INPUT.TYPE.HOME"
        defaultMessage="Home"
      />
    ),
  },
];

export const usaCities = [
  { label: "New York", value: "New York" },
  { label: "Los Angeles", value: "Los Angeles" },
  { label: "Chicago", value: "Chicago" },
  { label: "Houston", value: "Houston" },
  { label: "Phoenix", value: "Phoenix" },
  { label: "Philadelphia", value: "Philadelphia" },
  { label: "San Antonio", value: "San Antonio" },
  { label: "San Diego", value: "San Diego" },
  { label: "Dallas", value: "Dallas" },
  { label: "San Jose", value: "San Jose" },
  { label: "Austin", value: "Austin" },
  { label: "Jacksonville", value: "Jacksonville" },
  { label: "San Francisco", value: "San Francisco" },
  { label: "Columbus", value: "Columbus" },
  { label: "Indianapolis", value: "Indianapolis" },
];
export const CandidateStatus = [
  { label: "Pending", value: "pending" },
  { label: "Active", value: "active" },
  {
    label: "Rejected",
    value: "rejected",
  },
  {
    label: "Inactive",
    value: "deleted",
  },
];

export const Countries = [{ value: "US", label: "United States" }];

export const jobStatus = [
  {
    value: "open",
    label: (
      <FormattedMessage
        id="RECRUITER.POSTED.JOB.TEXT.OPEN"
        defaultMessage="Open"
      />
    ),
  },
  {
    value: "pause",
    label: (
      <FormattedMessage
        id="RECRUITER.POSTED.JOB.TEXT.PAUSE"
        defaultMessage="Pause"
      />
    ),
  },
  {
    value: "closed",
    label: (
      <FormattedMessage
        id="RECRUITER.POSTED.JOB.TEXT.CLOSED"
        defaultMessage="Closed"
      />
    ),
  },
];
export const individualJobStatus = [
  {
    value: "open",
    label: (
      <FormattedMessage
        id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.STATUS.OPEN"
        defaultMessage="Open"
      />
    ),
  },
  {
    value: "active",
    label: (
      <FormattedMessage
        id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.STATUS.ACTIVE"
        defaultMessage="Active"
      />
    ),
  },
  {
    value: "scheduled",
    label: (
      <FormattedMessage
        id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.STATUS.SCHEDULED"
        defaultMessage="Scheduled"
      />
    ),
  },
  {
    value: "in progress",
    label: (
      <FormattedMessage
        id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.STATUS.INPROGRESS"
        defaultMessage="In Progress"
      />
    ),
  },
  {
    value: "completed",
    label: (
      <FormattedMessage
        id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.STATUS.COMPLETED"
        defaultMessage="Completed"
      />
    ),
  },
  {
    value: "rejected",
    label: (
      <FormattedMessage
        id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.STATUS.REJECTED"
        defaultMessage="Rejected"
      />
    ),
  },
  {
    value: "cancelled",
    label: (
      <FormattedMessage
        id="INDIVIDUAL.JOBS.FILTER.DROPDOWN.STATUS.CANCELLED"
        defaultMessage="Cancelled"
      />
    ),
  },
];
export const IndiJobStatus = [
  {
    value: "publish",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.PUBLISH"
        defaultMessage="Publish"
      />
    ),
  },
  {
    value: "draft",
    label: (
      <FormattedMessage
        id="RECRUITER.WORKORDER.FILTER.TYPE.ASSIGNED.DRAFT"
        defaultMessage="Draft"
      />
    ),
  },
];

export const ApplicationStatus = [
  {
    value: "active",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.ACTIVE"
        defaultMessage="Active"
      />
    ),
  },
  {
    value: "awaiting-reviews",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.AWAITINGREVIEW"
        defaultMessage="awaiting-reviews"
      />
    ),
  },
  {
    value: "reviewed",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.REVIEWED"
        defaultMessage="Reviewed"
      />
    ),
  },
  {
    value: "contacting",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.CONTACTING"
        defaultMessage="Contacting"
      />
    ),
  },
  {
    value: "rejected",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.REJECTED"
        defaultMessage="Rejected"
      />
    ),
  },
  {
    value: "preonboarding",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.PREONBOARDING"
        defaultMessage="Pre-Onboarding"
      />
    ),
  },
  {
    value: "hired",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.HIRED"
        defaultMessage="Hired"
      />
    ),
  },
  {
    value: "shortlist",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.SHORTLIST"
        defaultMessage="Shortlist"
      />
    ),
  },
  {
    value: "withdrawn",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.WITHDRAWN"
        defaultMessage="Withdrawn"
      ></FormattedMessage>
    ),
  },
];
export const WorkOrderApplicationStatus = [
  {
    value: "active",
    label: (
      <FormattedMessage
        id="RECRUITER.CANDIDATES.FILTERS.ACTIVE"
        defaultMessage="Active"
      />
    ),
  },
  {
    value: "accept",
    label: (
      <FormattedMessage
        id="RECRUITER.SIDEBAR.ACTION.TYPE.ACCEPT"
        defaultMessage="Accept"
      />
    ),
  },
  {
    value: "reject",
    label: (
      <FormattedMessage
        id="RECRUITER.SIDEBAR.ACTION.TYPE.REJECT"
        defaultMessage="Reject"
      />
    ),
  },
];

export const WorkOrderPayType = [
  {
    value: "Fixed Rate",
    label: (
      <FormattedMessage
        id="RECRUITER.SCHEDULEWORKORDER.PAYTYPE.FIXED"
        defaultMessage="Fixed Rate"
      />
    ),
  },
  {
    value: "Hourly Rate",
    label: (
      <FormattedMessage
        id="RECRUITER.SCHEDULEWORKORDER.PAYTYPE.HOURLY"
        defaultMessage="Hourly Rate"
      />
    ),
  },
];
export const securityPermission = [
  {
    title: "Work Order Management",
    description: "User can View, Add, Update, Delete Permission",
    permission: [
      { title: "View Work Order" },
      { title: "Add Work Order" },
      { title: "Update Work Order" },
      { title: "Delete Work Order" },
    ],
  },
  {
    title: "Contractor Management",
    description: "User can View, Add, Update, Delete Permission",
    permission: [
      { title: "View Contractor" },
      { title: "Add Contractor" },
      { title: "Update Contractor" },
      { title: "Delete Contractor" },
    ],
  },
  {
    title: "Customer Management",
    description: "User can View, Add, Update, Delete Permission",
    permission: [
      { title: "View Customer" },
      { title: "Add Customer" },
      { title: "Update Customer" },
      { title: "Delete Customer" },
    ],
  },
];
export const IndFilterDates = [
  {
    title: (
      <FormattedMessage
        id="INDIVIDUAL.CLEANERS.FILTER.DATE.TAG.TODAY"
        defaultMessage="Today"
      />
    ),
    value: "todat",
  },
  {
    title: (
      <FormattedMessage
        id="INDIVIDUAL.CLEANERS.FILTER.DATE.TAG.WITHIN_THREE_DAYS"
        defaultMessage="Within 3 Days"
      />
    ),
    value: "3days",
  },
  {
    title: (
      <FormattedMessage
        id="INDIVIDUAL.CLEANERS.FILTER.DATE.TAG.WITHIN_A_WEEK"
        defaultMessage="Within A Week"
      />
    ),
    value: "withinaweek",
  },
  {
    title: (
      <FormattedMessage
        id="INDIVIDUAL.CLEANERS.FILTER.DATE.TAG.CHOOSE_DATES"
        defaultMessage="Choose Dates"
      />
    ),
    value: "custom",
  },
];
export const PaymentTypes = [
  {
    label: (
      <FormattedMessage
        id="RECRUITER.PAYMENT.TYPE.INCENTIVE"
        defaultMessage="Incentive"
      />
    ),
    value: "Incentive",
  },
  {
    label: (
      <FormattedMessage
        id="RECRUITER.PAYMENT.TYPE.RETENTION"
        defaultMessage="Retention"
      />
    ),
    value: "retention",
  },
  {
    label: (
      <FormattedMessage
        id="RECRUITER.PAYMENT.TYPE.OVERTIME"
        defaultMessage="Overtime"
      />
    ),
    value: "overtime",
  },
  {
    label: (
      <FormattedMessage
        id="RECRUITER.PAYMENT.TYPE.PERFORMANCE"
        defaultMessage="Performance"
      />
    ),
    value: "performance",
  },
  {
    label: (
      <FormattedMessage id="RECRUITER.PAYMENT.TYPE.TIP" defaultMessage="Tip" />
    ),
    value: "tip",
  },
];

export const CHAT_TYPE = {
  JOB_ACCEPTED: "job_accepted",
  JOB_OFFERED: "job_offered",
  JOB_REJECTED: "job_rejected",
  DATE_CHANGE: "date_change",
  START_JOB: "start_job",
  END_JOB: "end_job",
  PAYMENT_DONE: "payment_done",
  RATING: "rating",
};
export const branchServiceType = [
  { value: "SL", label: "RECRUITER.BRANCH.TYPE.SERVICE" },
  { value: "HO", label: "RECRUITER.BRANCH.TYPE.SERVICE.HEAD.OFFICE" },
  { value: "RHO", label: "RECRUITER.BRANCH.TYPE.SERVICE.REGIONAL.HEAD.OFFICE" },
];
